import React from 'react';

type RailContextData = {
  onFacetChange?: (option: { [_: string]: unknown }) => void;
  scrollableRef?: HTMLElement | null;
  stickyBuffer?: number;
};

const RailContext = React.createContext<RailContextData>({});

export default RailContext;
